import Content from "components/Content";
import Label from "components/Label";
import React, { FC } from "react";

import styles from "./styles.module.scss";

interface Props {
  title: string;
  subtitle: string;
  partners: string[];
}

const ExclusiveBenefits: FC<Props> = ({ title, subtitle, partners }) => {
  return (
    <Content
      containerClassName={styles.wrapper}
      contentClassName={styles.container}
    >
      <Label variant="h-centered" color="white" className={styles.title}>
        {title}
      </Label>
      <Label variant="s-centered" color="white" className={styles.subtitle}>
        {subtitle}
      </Label>
      <div className={styles.partners}>
        {partners.map((partner) => (
          <img alt="" src={partner} className={styles.img} />
        ))}
      </div>
    </Content>
  );
};

export default ExclusiveBenefits;
